import { create } from 'zustand'

interface FloorPlanPanelState {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  reset: () => void
}

// Controls the floor-plan editor panel, toggled from the header (analogous to
// useMenuSidebarStore). Open by default so the editing controls are visible.
export const useFloorPlanPanelStore = create<FloorPlanPanelState>(set => ({
  isOpen: true,
  setIsOpen: value => set({ isOpen: value }),
  reset: () => set({ isOpen: true })
}))
